import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from '../../../Shared/AdminNavbar/Navbar';
import { FaTrash, FaEdit } from "react-icons/fa";
import ReusableTable from '../../../Layout/ReusableTable';
import baseURL from '../../../Apiurs/Apiurls';
import axios from 'axios';

const TeamMembers = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [message, setMessage] = useState("");
  const [teamMembers, setTeamMembers] = useState(location.state?.teamMembers || []);

  useEffect(() => {
    if (!location.state?.teamMembers) {
      console.warn("No team members found in state.");
    }
  }, [location.state]);

  const handleDeleteEmployee = async (id) => {
    try {
      const response = await axios.delete(`${baseURL}/api/employees/${id}`);
      if (response.status === 204) {
        setTeamMembers(prevMembers => prevMembers.filter(member => member.id !== id));
        setMessage("Employee deleted successfully!");
        setTimeout(() => setMessage(""), 3000);
      }
    } catch (error) {
      console.error("Error deleting employee:", error);
      setMessage("Failed to delete employee. Please try again.");
      setTimeout(() => setMessage(""), 3000);
    }
  };

  const memberColumns = [
    {
      key: "id",
      title: "Employee ID",
      render: (row) => `EMP${String(row.id).padStart(5, "0")}`,
    },
    {
      key: "name",
      title: "Name",
      render: (row) => row.name,
    },
    {
      key: "mobile",
      title: "Mobile",
      render: (row) => row.mobile,
    },
    {
      key: "email",
      title: "Email",
      render: (row) => row.email,
    },
  {
  key: "role",
  title: "Designation",
  render: (row) =>
    row.role === "s-employee"
      ? "Sales Associate"
      : row.role === "employee"
      ? "Quotation Associate"
      : row.role,
},

    {
      key: "actions",
      title: "Actions",
      render: (row) => (
        <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
          <FaEdit
            style={{ color: "#ff9966", cursor: "pointer" }}
            onClick={() => navigate(`/editemployee/${row.id}`)}
            title="Edit"
          />
          <FaTrash
            style={{ color: "#ff9966", cursor: "pointer" }}
            onClick={() => handleDeleteEmployee(row.id)}
            title="Delete"
          />
        </div>
      ),
    },
  ];

  return (
    <div className="Admin-myteamcontainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Admin-myteam ${collapsed ? "collapsed" : ""}`}>
        <div className="ViewCustomer-container mb-5">
          <div className="ViewCustomer-table-container">
            <div className="back-button mt-3 d-flex justify-content-start">
              <button className="btn btn-secondary" onClick={() => navigate(-1)}>
                Back
              </button>
            </div>
            <h2 className='text-center'>Team Members</h2>
            {message && <div className="alert alert-success">{message}</div>}
            <ReusableTable
              title="Team Members"
              data={teamMembers}
              columns={memberColumns}
              initialEntriesPerPage={5}
              searchPlaceholder="Search team members..."
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamMembers;